/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientTeamRole = {
    Undefined: 'UNDEFINED',
    Member: 'MEMBER',
    Admin: 'ADMIN'
} as const;
export type ClientTeamRole = typeof ClientTeamRole[keyof typeof ClientTeamRole];


export function instanceOfClientTeamRole(value: any): boolean {
    for (const key in ClientTeamRole) {
        if (Object.prototype.hasOwnProperty.call(ClientTeamRole, key)) {
            // @ts-ignore
            if (ClientTeamRole[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientTeamRoleFromJSON(json: any): ClientTeamRole {
    return ClientTeamRoleFromJSONTyped(json, false);
}

export function ClientTeamRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamRole {
    return json as ClientTeamRole;
}

export function ClientTeamRoleToJSON(value?: ClientTeamRole | null): any {
    return value as any;
}

